import MainPages from './MainPages';

export default MainPages;
